// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 12%27%3E%3Cpolygon fill=%27rgb%28102,102,102%29%27 points=%278,12 0,0 16,0%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font: 100%/1.5 opensans, Corbel, "Lucida Grande", "Trebuchet Ms", sans-serif;
  color: #111;
  background-color: #fff;
  margin: 10px auto;
  max-width: 100%vh;
  max-height: 1000px;
}

.calculator-container {
  display: flex;
  justify-content: space-evenly;
  background: #ddd;
  padding: 100px 40px;
}


h1 {
  text-align: center;
  font-size: 2.5em;
  font-weight: 700 !important;
  margin: 15px;
}

.text-left {
  float: left;
  width: 30%;
  align-content: center;
  padding: 0 40px;
  text-align: center;
}
.description {
  font-size: 1.2rem;
}

h4 {
  text-align: center;
}

a {
  text-decoration: none;;
}

.quote_btn {
  display: inline-flex;
  text-decoration: none;
  background: #1d1b1b;
  color: white;
  border-radius: 25px;
  text-align: center;
  cursor: pointer;
  padding: 5px 8px;
  font-weight: bold;
  margin: 15px 0;
}

.quote-space {
  border-radius: 0 0 0 25px;
  font-size: 1rem;
  padding-left: 25px !important;
  
}

.quote_btn:hover {
  background-color: #af202f;
  border: none;
  color: white;
}

.input {
  background-color: white;
  color: #1d1b1b;
  padding: 2% 5% 4%;
  border-radius: 25px;
  height: 94%;
}

.output {
  padding: 0 20px;
}

#output-results {
  border: none;
  color: #1d1b1b;
  border-radius:25px;
}

.output-header {
  color: white;
  background-color: #1d1b1b;
  padding: 1% 2% 1% 5%;
}

.thead_1 {
  border-radius: 25px 0 0 0;
}

.thead_3 {
  border-radius:   0 25px  0 0;
}

.row {
  display: flex;
}

.column {
  flex: 50% 1;
}

.question {
  padding-right: 5%;
}

.question_name {
  margin-block-end: 2px;
}

.result {
  text-align: center;
}

.result h2 {
  font-size: 2.5em;
  margin-bottom: 0;
}

h3 {
  font-size: 1.3em;

}

.dropdown {
  position: relative;
  display: block;
  margin-top: 0.5em;
  padding: 0;
}

.styled-table {
  border-collapse: collapse;
  font-size: 0.9em;
  font-family: sans-serif;
  width: 100%;
}

.styled-table th {
  background-color: #565656;
  color: #fff;
  text-align: center;
}

.styled-table th,
.styled-table td {
  padding: 0 6px;
}

.styled-table tbody tr {
  background: white;
}

.styled-table tbody tr:nth-of-type(even) {
  background-color: #f3f3f3;
}


.dropdown select,
.input_lfield input {
  width: 100%;
  margin: 0;
  background: none;
  border: 1px solid transparent;
  outline: none;
  box-sizing: border-box;
  appearance: none;
  -webkit-appearance: none;
  font-size: 1.25em;
  color: #444;
  padding: 0.6em 1.9em 0.5em 0.8em;
  line-height: 1.3;
  opacity: 80%;
}

.emailfield input {
  background: #f3f3f3;
}

.dropdown::after {
  content: "";
  position: absolute;
  width: 9px;
  height: 8px;
  top: 50%;
  right: 1em;
  margin-top: -4px;
  z-index: 2;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___})
    0 0 no-repeat;
  pointer-events: none;
}

.calculate-button {
  margin-top: 2.9em;
  border-radius: 25px;
  background-color: #ce1226;
  color: white;
  border: none;
  font-size: 1.3em;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  padding: 10px;
}

.calculate-button:hover {
  background-color: #af202f;
}

.result-list {
  display: flex;
  align-items: center;
}

.return-btn {
cursor: pointer;}

.icon {
  width: 30px;
  margin: 0 15px;
}

.footer_link {
  text-decoration: none;
  color: #af202f;
}

.footer_link:hover {
  text-decoration: underline;
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .dropdown select::-ms-expand {
    display: none;
  }
  select:focus::-ms-value {
    background: transparent;
    color: #222;
  }
}

body:last-child .dropdown::after,
x:-moz-any-link {
  display: none;
}

body:last-child .dropdown select,
x:-moz-any-link {
  padding-right: 0.8em;
}

input:-webkit-autofill,
input:-webkit-autofill:focus {
  -webkit-transition: background-color 0s 600000s, color 0s 600000s !important;
  transition: background-color 0s 600000s, color 0s 600000s !important;
}

_::-moz-progress-bar,
body:last-child .dropdown {
  overflow: hidden;
}

_::-moz-progress-bar,
body:last-child .dropdown:after {
  display: block;
}

_::-moz-progress-bar,
body:last-child .dropdown select {
  padding-right: 1.9em;
  -moz-appearance: window;
  text-indent: 0.01px;
  text-overflow: "";
  width: 110%;
}

_::-moz-progress-bar,
body:last-child .dropdown select:focus {
  outline: 2px solid rgb(243, 243, 243);
}

x:-o-prefocus,
.dropdown::after {
  display: none;
}

.dropdown option:hover {
  background-color: #888;
}

select:focus {
  outline: none;
  box-shadow: 0 0 1px 3px rgb(243, 243, 243);
  background-color: transparent;
  color: #222;
  border: 1px solid #aaa;
}

select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #000;
}

option {
  font-weight: normal;
}

.button {
  border: 1px solid #bbb;
  border-radius: 0.3em;
  background: #f3f3f3;
}

.cost-value {
  font-size: 2em;
  text-align: center;
  opacity: 70%;
}

#energy-use-row {
  border-bottom: none !important;
}

#quote-btn-row {
  background-color: white !important;
}

.quote-btn-data, .quote-btn-data1 {
  text-align: center;
}
.quote-btn-data1 {
border-radius: 0 0 25px 0;
}

@media only screen and (max-width: 802px) {
  body {
    margin: 0 auto;
  }

  .calculator-container {
    margin: 0;
    flex-direction: column;
    padding: 80px 0;
  }

  .row {
    display: block;
  }

  h1 {
    font-size: 2.5em;
  }

  .dropdown {
    margin-top: 0;
  }

  .input {
    padding-bottom: 30PX;
  }

  .question_name {
    margin-top: 10px;
  }

  #email, #project-size, .dropdown select {
    font-size: 1em;
    padding: 0.3em 1.9em 0.3em 0.8em;
  }

  h3, h2 {
    font-size: 1em;
  }

  .cost-value {
    font-size: 1.2em;
  }

  .quote_btn {
    display: inline-flex;
    border-radius: 25px;
    line-height: 15px;
    margin: 5px;
    padding: 10px 15px;
  }

  .question{
    padding-right: 0;
  }

  .output {
    width: 96%;
  }
  
  .text-left{
    width: 85%;
  }
}`, "",{"version":3,"sources":["webpack://./src/costCalculator.css"],"names":[],"mappings":"AAAA;EACE,4EAA4E;EAC5E,WAAW;EACX,sBAAsB;EACtB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,UAAU;EACV,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,6BAA6B;;AAE/B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;;AAElB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;;AAGA;;EAEE,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,6BAA6B;EAC7B,aAAa;EAGb,sBAAsB;EACtB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,WAAW;EACX,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,UAAU;EACV;iBACe;EACf,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;AACA,eAAe,CAAC;;AAEhB;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,uBAAuB;IACvB,WAAW;EACb;AACF;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,4EAAoE;EAApE,oEAAoE;AACtE;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;AACb;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,6BAA6B;EAC7B,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;AACA;AACA,yBAAyB;AACzB;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gCAAgC;EAClC;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":["body {\n  font: 100%/1.5 opensans, Corbel, \"Lucida Grande\", \"Trebuchet Ms\", sans-serif;\n  color: #111;\n  background-color: #fff;\n  margin: 10px auto;\n  max-width: 100%vh;\n  max-height: 1000px;\n}\n\n.calculator-container {\n  display: flex;\n  justify-content: space-evenly;\n  background: #ddd;\n  padding: 100px 40px;\n}\n\n\nh1 {\n  text-align: center;\n  font-size: 2.5em;\n  font-weight: 700 !important;\n  margin: 15px;\n}\n\n.text-left {\n  float: left;\n  width: 30%;\n  align-content: center;\n  padding: 0 40px;\n  text-align: center;\n}\n.description {\n  font-size: 1.2rem;\n}\n\nh4 {\n  text-align: center;\n}\n\na {\n  text-decoration: none;;\n}\n\n.quote_btn {\n  display: inline-flex;\n  text-decoration: none;\n  background: #1d1b1b;\n  color: white;\n  border-radius: 25px;\n  text-align: center;\n  cursor: pointer;\n  padding: 5px 8px;\n  font-weight: bold;\n  margin: 15px 0;\n}\n\n.quote-space {\n  border-radius: 0 0 0 25px;\n  font-size: 1rem;\n  padding-left: 25px !important;\n  \n}\n\n.quote_btn:hover {\n  background-color: #af202f;\n  border: none;\n  color: white;\n}\n\n.input {\n  background-color: white;\n  color: #1d1b1b;\n  padding: 2% 5% 4%;\n  border-radius: 25px;\n  height: 94%;\n}\n\n.output {\n  padding: 0 20px;\n}\n\n#output-results {\n  border: none;\n  color: #1d1b1b;\n  border-radius:25px;\n}\n\n.output-header {\n  color: white;\n  background-color: #1d1b1b;\n  padding: 1% 2% 1% 5%;\n}\n\n.thead_1 {\n  border-radius: 25px 0 0 0;\n}\n\n.thead_3 {\n  border-radius:   0 25px  0 0;\n}\n\n.row {\n  display: flex;\n}\n\n.column {\n  flex: 50%;\n}\n\n.question {\n  padding-right: 5%;\n}\n\n.question_name {\n  margin-block-end: 2px;\n}\n\n.result {\n  text-align: center;\n}\n\n.result h2 {\n  font-size: 2.5em;\n  margin-bottom: 0;\n}\n\nh3 {\n  font-size: 1.3em;\n\n}\n\n.dropdown {\n  position: relative;\n  display: block;\n  margin-top: 0.5em;\n  padding: 0;\n}\n\n.styled-table {\n  border-collapse: collapse;\n  font-size: 0.9em;\n  font-family: sans-serif;\n  width: 100%;\n}\n\n.styled-table th {\n  background-color: #565656;\n  color: #fff;\n  text-align: center;\n}\n\n.styled-table th,\n.styled-table td {\n  padding: 0 6px;\n}\n\n.styled-table tbody tr {\n  background: white;\n}\n\n.styled-table tbody tr:nth-of-type(even) {\n  background-color: #f3f3f3;\n}\n\n\n.dropdown select,\n.input_lfield input {\n  width: 100%;\n  margin: 0;\n  background: none;\n  border: 1px solid transparent;\n  outline: none;\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n  appearance: none;\n  -webkit-appearance: none;\n  font-size: 1.25em;\n  color: #444;\n  padding: 0.6em 1.9em 0.5em 0.8em;\n  line-height: 1.3;\n  opacity: 80%;\n}\n\n.emailfield input {\n  background: #f3f3f3;\n}\n\n.dropdown::after {\n  content: \"\";\n  position: absolute;\n  width: 9px;\n  height: 8px;\n  top: 50%;\n  right: 1em;\n  margin-top: -4px;\n  z-index: 2;\n  background: url(\"data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 12'%3E%3Cpolygon fill='rgb(102,102,102)' points='8,12 0,0 16,0'/%3E%3C/svg%3E\")\n    0 0 no-repeat;\n  pointer-events: none;\n}\n\n.calculate-button {\n  margin-top: 2.9em;\n  border-radius: 25px;\n  background-color: #ce1226;\n  color: white;\n  border: none;\n  font-size: 1.3em;\n  font-weight: bold;\n  cursor: pointer;\n  width: 100%;\n  padding: 10px;\n}\n\n.calculate-button:hover {\n  background-color: #af202f;\n}\n\n.result-list {\n  display: flex;\n  align-items: center;\n}\n\n.return-btn {\ncursor: pointer;}\n\n.icon {\n  width: 30px;\n  margin: 0 15px;\n}\n\n.footer_link {\n  text-decoration: none;\n  color: #af202f;\n}\n\n.footer_link:hover {\n  text-decoration: underline;\n}\n\n@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n  .dropdown select::-ms-expand {\n    display: none;\n  }\n  select:focus::-ms-value {\n    background: transparent;\n    color: #222;\n  }\n}\n\nbody:last-child .dropdown::after,\nx:-moz-any-link {\n  display: none;\n}\n\nbody:last-child .dropdown select,\nx:-moz-any-link {\n  padding-right: 0.8em;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:focus {\n  transition: background-color 0s 600000s, color 0s 600000s !important;\n}\n\n_::-moz-progress-bar,\nbody:last-child .dropdown {\n  overflow: hidden;\n}\n\n_::-moz-progress-bar,\nbody:last-child .dropdown:after {\n  display: block;\n}\n\n_::-moz-progress-bar,\nbody:last-child .dropdown select {\n  padding-right: 1.9em;\n  -moz-appearance: window;\n  text-indent: 0.01px;\n  text-overflow: \"\";\n  width: 110%;\n}\n\n_::-moz-progress-bar,\nbody:last-child .dropdown select:focus {\n  outline: 2px solid rgb(243, 243, 243);\n}\n\nx:-o-prefocus,\n.dropdown::after {\n  display: none;\n}\n\n.dropdown option:hover {\n  background-color: #888;\n}\n\nselect:focus {\n  outline: none;\n  box-shadow: 0 0 1px 3px rgb(243, 243, 243);\n  background-color: transparent;\n  color: #222;\n  border: 1px solid #aaa;\n}\n\nselect:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #000;\n}\n\noption {\n  font-weight: normal;\n}\n\n.button {\n  border: 1px solid #bbb;\n  border-radius: 0.3em;\n  background: #f3f3f3;\n}\n\n.cost-value {\n  font-size: 2em;\n  text-align: center;\n  opacity: 70%;\n}\n\n#energy-use-row {\n  border-bottom: none !important;\n}\n\n#quote-btn-row {\n  background-color: white !important;\n}\n\n.quote-btn-data, .quote-btn-data1 {\n  text-align: center;\n}\n.quote-btn-data1 {\nborder-radius: 0 0 25px 0;\n}\n\n@media only screen and (max-width: 802px) {\n  body {\n    margin: 0 auto;\n  }\n\n  .calculator-container {\n    margin: 0;\n    flex-direction: column;\n    padding: 80px 0;\n  }\n\n  .row {\n    display: block;\n  }\n\n  h1 {\n    font-size: 2.5em;\n  }\n\n  .dropdown {\n    margin-top: 0;\n  }\n\n  .input {\n    padding-bottom: 30PX;\n  }\n\n  .question_name {\n    margin-top: 10px;\n  }\n\n  #email, #project-size, .dropdown select {\n    font-size: 1em;\n    padding: 0.3em 1.9em 0.3em 0.8em;\n  }\n\n  h3, h2 {\n    font-size: 1em;\n  }\n\n  .cost-value {\n    font-size: 1.2em;\n  }\n\n  .quote_btn {\n    display: inline-flex;\n    border-radius: 25px;\n    line-height: 15px;\n    margin: 5px;\n    padding: 10px 15px;\n  }\n\n  .question{\n    padding-right: 0;\n  }\n\n  .output {\n    width: 96%;\n  }\n  \n  .text-left{\n    width: 85%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
